import React from 'react';
import { ChevronRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { BottomNav } from '../components/BottomNav';
import { useBookingCart } from '../contexts/BookingCartContext';
export function BookingsPopulatedScreen() {
  const navigate = useNavigate();
  const {
    confirmedBookings
  } = useBookingCart();
  const getStatusColor = (status: string) => {
    switch (status) {
      case 'Upcoming':
        return 'bg-[#c7f61e] text-[#1f5070]';
      case 'Confirmed':
        return 'bg-[#3dc7e3] text-white';
      case 'Completed':
        return 'bg-gray-400 text-white';
      case 'Cancelled':
        return 'bg-red-100 text-red-600';
      default:
        return 'bg-gray-200 text-gray-600';
    }
  };
  return <div className="h-screen w-full flex flex-col bg-gray-50" data-id="element-390">
      <Header title="My Bookings" showLogo={true} data-id="element-391" />

      {/* Pull to refresh indicator */}
      <div className="bg-white px-6 py-2 flex justify-center" data-id="element-392">
        <div className="w-8 h-1 bg-gray-300 rounded-full" data-id="element-393"></div>
      </div>

      <div className="flex-1 overflow-auto px-4 py-4 space-y-3" data-id="element-394">
        {confirmedBookings.length === 0 ? <div className="flex flex-col items-center justify-center py-12 text-center" data-id="element-395">
            <div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mb-4" data-id="element-396">
              <ChevronRightIcon className="w-8 h-8 text-gray-400" data-id="element-397" />
            </div>
            <h3 className="text-lg font-bold text-[#1f5070] mb-2" data-id="element-398">
              No Bookings Yet
            </h3>
            <p className="text-sm text-[#666666] max-w-xs" data-id="element-399">
              Your confirmed bookings will appear here
            </p>
          </div> : confirmedBookings.map(booking => <button key={booking.id} onClick={() => navigate(`/bookings/confirmation/${booking.bookingReference}`)} className="w-full bg-white rounded-xl shadow-md p-4 flex items-center gap-4 active:scale-98 transition-transform text-left" data-id="element-400">
              {/* Court thumbnail */}
              <img src={booking.image} alt={booking.courtName} className="w-20 h-20 rounded-xl object-cover flex-shrink-0" data-id="element-401" />

              {/* Booking details */}
              <div className="flex-1 min-w-0" data-id="element-402">
                <div className="mb-1" data-id="element-403">
                  <h3 className="text-base font-bold text-[#1f5070]" data-id="element-404">
                    {booking.courtName}
                  </h3>
                  <p className="text-xs text-[#666666]" data-id="element-405">
                    {booking.venueName} • {booking.venueLocation}
                  </p>
                </div>
                <p className="text-sm text-[#666666] mb-2" data-id="element-406">
                  {booking.date} • {booking.time}
                </p>
                <div className="flex items-center gap-2" data-id="element-407">
                  <span className={`inline-block px-3 py-1 text-xs font-bold rounded-full ${getStatusColor(booking.status)}`} data-id="element-408">
                    {booking.status}
                  </span>
                  <span className="text-xs text-[#3dc7e3]" data-id="element-409">
                    {booking.paymentMethod}
                  </span>
                </div>
              </div>

              {/* Chevron */}
              <ChevronRightIcon className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-410" />
            </button>)}
      </div>

      <BottomNav data-id="element-411" />
    </div>;
}